import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetCollection_pointsInvoice_reminder_alerts = z.any()
export type TagsGetCollection_pointsInvoice_reminder_alerts = z.infer<typeof tagsGetCollection_pointsInvoice_reminder_alerts>

export const querystringGetCollection_pointsInvoice_reminder_alerts = z.object({ "buildingId": z.string().uuid().optional() })
export type QuerystringGetCollection_pointsInvoice_reminder_alerts = z.infer<typeof querystringGetCollection_pointsInvoice_reminder_alerts>

export const responseGetCollection_pointsInvoice_reminder_alerts = z.object({ "payload": z.array(z.object({ "collectionPointId": z.string(), "collectionPointName": z.string(), "buildingId": z.string(), "buildingName": z.string(), "missing": z.array(z.object({ "periodFrom": z.string().date(), "periodTo": z.string().date(), "dueDate": z.string().date(), "historical": z.boolean() })) })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetCollection_pointsInvoice_reminder_alerts = z.infer<typeof responseGetCollection_pointsInvoice_reminder_alerts>

interface IGetCollection_pointsInvoice_reminder_alerts extends BaseMethodType {
  tags: TagsGetCollection_pointsInvoice_reminder_alerts,
  querystring: QuerystringGetCollection_pointsInvoice_reminder_alerts,
  response: ResponseGetCollection_pointsInvoice_reminder_alerts
}
export const URL = '/collection-points/invoice-reminder-alerts'
export const validation = {
  get: {
    tags: tagsGetCollection_pointsInvoice_reminder_alerts,
    querystring: querystringGetCollection_pointsInvoice_reminder_alerts,
    response: responseGetCollection_pointsInvoice_reminder_alerts
  }
}
export interface Collection_pointsInvoice_reminder_alerts extends BaseRouteType {
  get: IGetCollection_pointsInvoice_reminder_alerts
}